import { Link } from "react-router-dom";
import site from "@/content/site.json";

const A = site.author;

export function AuthorBox({ date }) {
  return (
    <aside className="glass p-5 mt-8 flex gap-4 items-start" data-testid="article-author-box">
      <img src="/pillarwealth-icon.png" alt="" className="h-12 w-12 rounded-xl shrink-0" />
      <div>
        <p className="text-sm"><span className="font-semibold" data-testid="article-author-name">{A.name}</span> · {A.org}</p>
        <p className="text-xs text-muted-foreground mt-0.5">Published {date} · Educational information, not personal financial advice</p>
        <p className="text-sm text-slate-600 dark:text-slate-400 mt-2">{A.bio} <Link to="/editorial-policy" className="text-cyan-700 dark:text-cyan-400 underline" data-testid="article-editorial-link">Editorial policy</Link> · <Link to="/contact" className="text-cyan-700 dark:text-cyan-400 underline" data-testid="article-contact-link">Report a correction</Link></p>
      </div>
    </aside>
  );
}
